import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Autocomplete, TextField } from "@mui/material";
import { forwardRef } from "react";
import { MetadataInputProps } from "../metadata-input-index";

const MetadataInputTitles = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { onChange, data, value } = props;

  return (
    <Autocomplete
      id={data.tagName!}
      // options management
      options={[]}
      // value management
      value={value?.value?.map((el) => el.text) || []}
      onChange={(e, value) => onChange(value.length > 0 ? value : undefined, data.id)}
      // render input
      multiple
      freeSolo
      popupIcon={<ExpandMoreRoundedIcon />}
      renderInput={(params) => <TextField sx={{ mt: "-24px" }} {...params} />}
    />
  );
});

export default MetadataInputTitles;
